import React from "react";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  image: {
    width: "100%",
    paddingBottom: "100%",
    backgroundSize: "cover",
    backgroundPosition: "top"
  },
  container: {
    position: "relative"
  },
  note: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: alpha(theme.palette.primary.main, 0.2)
  },
  noteText: {
    marginRight: theme.spacing(1),
    verticalAlign: "top",
    color: theme.palette.common.white
  }
}));

export default function CourseCardPicture(props) {
  const classes = useStyles();
  const { t } = useTranslation();

  const { imageSrc, hasNote, isSelfAssigned } = props;

  let courseCardPictureNote = isSelfAssigned
    ? t("courseCard.courseCardPicture.note.saved")
    : t("courseCard.courseCardPicture.note.assigned");

  return (
    <Box position="relative">
      {hasNote && (
        <Box className={classes.note}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            p={1}
          >
            <Typography variant="subtitle2" className={classes.noteText}>
              {courseCardPictureNote}
            </Typography>
            <CheckCircleIcon color="primary" />
          </Box>
        </Box>
      )}
      <div
        style={{ backgroundImage: `url("${imageSrc}")` }}
        className={classes.image}
      />
    </Box>
  );
}

CourseCardPicture.propTypes = {
  imageSrc: PropTypes.string,
  hasNote: PropTypes.bool
};

CourseCardPicture.defaultProps = {
  isSelfAssigned: true
};
